import { createEntityMutation } from '../../createEntityMutation';
import { ConvertibleService } from '@wealthlane/api-services/wealthlane-captable-service';

export interface DownloadDocumentResult {
  name?: string | null;
  content?: string | null;
}

export const useDownloadConvertibleDocument = createEntityMutation<
  DownloadDocumentResult,
  string
>({
  mutationFn: (documentDetailId) =>
    ConvertibleService.postApiCapTableApiAppConvertibleDownloadConvertibleDocument({
      documentDetailId,
    }),
});
